export default {
    mapGeofenceBulk_title: "Bulk Geofence Actions",
    mapGeofenceBulk_iconType: "Icon Type",
    mapGeofenceBulk_Icon_color: "Icon & Color",
    mapGeofenceBulk_geofence: "Geofence updated",
    mapGeofenceBulk_geofence_selected: "Geofences Selected",
    mapGeofenceBulk_selectedGeofences: "The selected geofences will belong to the following Group",
    mapGeofenceBulk_tag: "Tag",
};